import { render, staticRenderFns } from "./JourneyConnectionDelay.vue?vue&type=template&id=3852f065&scoped=true&"
import script from "./JourneyConnectionDelay.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionDelay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852f065",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3852f065')) {
      api.createRecord('3852f065', component.options)
    } else {
      api.reload('3852f065', component.options)
    }
    module.hot.accept("./JourneyConnectionDelay.vue?vue&type=template&id=3852f065&scoped=true&", function () {
      api.rerender('3852f065', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/GeneralSettings/JourneyConnectionDelay.vue"
export default component.exports